<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-indent: 0px; text-align: center;padding-top:150px;"><img alt="" src="media/file1.png" style="width:3.53333in;height:3.57361in;filter:grayscale(100%);"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2694f0a8